import React from "react";
import { useTranslation } from "react-i18next";
import orderConfirmationImg from "assets/img/product-photos/Order_confirmation.jpg";
import { BANK_DETAILS, TWINT_PAYMENT_URL } from "./bankDetails";

function OrderConfirmation({ paymentMethod }) {
  const { t } = useTranslation();
  return (
    <div className="cart-rd-confirmation">
      <img
        src={orderConfirmationImg}
        alt={t("warenkorb.Confirmation image alt")}
        className="cart-rd-confirmation-img"
      />
      <h2 className="cart-rd-confirmation-title">{t("warenkorb.Confirmation title")}</h2>
      <p className="cart-rd-confirmation-body">{t("warenkorb.Confirmation body")}</p>

      {paymentMethod === "TWINT" ? (
        <div className="cart-rd-confirmation-payment">
          <h3>{t("warenkorb.Twint heading")}</h3>
          <p>{t("warenkorb.Twint body")}</p>
          <button
            type="button"
            className="cart-rd-twint-btn"
            style={{
              width: "auto",
              height: 58,
              borderRadius: 6,
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
              backgroundColor: "transparent",
              border: "none",
              alignItems: "center",
              padding: 0
            }}
            onClick={() => window.open(TWINT_PAYMENT_URL, "_blank")}
          >
            <span className="cart-rd-twint-badge">
              <span role="img" aria-label="Smartphone">📱</span> {t("warenkorb.Twint button")}
            </span>
          </button>
          <p className="cart-rd-confirmation-note">{t("warenkorb.Payment note")}</p>
        </div>
      ) : (
        <div className="cart-rd-confirmation-payment">
          <h3>{t("warenkorb.Transfer heading")}</h3>
          <p>{t("warenkorb.Transfer body")}</p>
          <dl className="bank-details">
            <div>
              <dt>IBAN</dt>
              <dd className="bank-details-iban">{BANK_DETAILS.iban}</dd>
            </div>
            <div>
              <dt>{t("warenkorb.Payable to")}</dt>
              <dd>
                {BANK_DETAILS.holder}
                <br />
                {BANK_DETAILS.street}
                <br />
                {BANK_DETAILS.city}
              </dd>
            </div>
          </dl>
          <p className="cart-rd-confirmation-note">{t("warenkorb.Payment note")}</p>
        </div>
      )}
    </div>
  );
}

export default OrderConfirmation;
